import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { obtenerInventarios, historialComprasFolios, historialEntregasHologramas } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';
import ModalHistorialComprasComponent from './ModalHistorialComprasComponent';
import ModalHistorialEntregasComponent from './ModalHistorialEntregasComponent';

const PanelEntregasComponent = () => {

    const dispatch = useDispatch()
    const inventarios = useSelector(store => store.ModuloInventario.data)

    const [openModalCompras, setOpenModalCompras] = React.useState(false)
    const [openModalEntregas, setOpenModalEntregas] = React.useState(false)

    React.useEffect(async () => {
        await dispatch(obtenerInventarios())
    }, [])

    const columns = [
        { field: 'numAsociado', headerName: 'Número de asociado', headerAlign: 'center', width: 170 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 495 },
        { field: 'invMezcal', headerName: 'Inventario mezcal', headerAlign: 'center', width: 160 },
        { field: 'invBebidasMezcal', headerName: 'Inventario bebidas con mezcal', headerAlign: 'center', width: 250 },
        { field: 'historial', headerName: 'Historial', headerAlign: 'center', width: 210,
            renderCell: (params) => (
                <>
                <button className={`btn btn-outline-success`} style={{marginRight: '10px'}} onClick={() => historialCompras(params)}>Compras</button> 
                <button className={`btn btn-outline-success`} onClick={() => historialEntregas(params)} >Entregas</button>
                </>
            )
        },
    ]

    const rows = []

    inventarios?.map(anexo => {
        let hologramasmezcal = ''
        if (anexo?.hologramasmezcal != '') hologramasmezcal = anexo?.hologramasmezcal
        else hologramasmezcal = '0'
        let hologramasbebidas = ''
        if (anexo?.hologramasbebidas != '') hologramasbebidas = anexo?.hologramasbebidas
        else hologramasbebidas = '0'
        rows.push({
            id: uuidv4(), numAsociado: anexo?.cliente?.numerosocio, razonSocial: anexo?.cliente?.nombrerazonsocial,
            invMezcal: hologramasmezcal, invBebidasMezcal: hologramasbebidas, idloginfc40_solicitudadquisicionholo: anexo?.cliente?.idlogin
        })
    })

    const historialCompras = async (params) => {
        await dispatch(historialComprasFolios(params.row.idloginfc40_solicitudadquisicionholo))
        setOpenModalCompras(true)
    }

    const historialEntregas = async (params) => {
        await dispatch(historialEntregasHologramas(params.row.idloginfc40_solicitudadquisicionholo))
        setOpenModalEntregas(true)
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <div className="container">
            <Box sx={{ height: 530, width: '100%', mt: 7}}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    pageSize={10}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#4399A4',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        }
                    }}
                />
            </Box>
            { openModalCompras &&
                <ModalHistorialComprasComponent setOpenModalCompras={{ setOpenModalCompras }} ></ModalHistorialComprasComponent>
            }
            { openModalEntregas &&
                <ModalHistorialEntregasComponent setOpenModalEntregas={{ setOpenModalEntregas }} ></ModalHistorialEntregasComponent>
            }
        </div>
    );

};
export default PanelEntregasComponent